import React, { useState, useEffect } from 'react';
import './HeroBanner.css';

interface Slide {
  image: string;
  title: string;
  subtitle: string;
}

const HeroBanner: React.FC = () => {
  const slides: Slide[] = [
    {
      image: '/drone2.png',
      title: 'Agricultura Inteligente com a VULPES',
      subtitle: 'Gestão eficiente da sua exploração agrícola'
    },
    {
      image: '/sensor.png',
      title: 'Rega Inteligente',
      subtitle: 'Sistema automatizado para rega eficiente'
    },
    {
      image: '/energia.png',
      title: 'Energia Inteligente',
      subtitle: 'Otimize o consumo de energia nas suas explorações'
    },
    {
      image: '/cadernos.png',
      title: 'Cadernos de Campo Digitais',
      subtitle: 'Registe e acompanhe todas as suas atividades'
    }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [isPaused, slides.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section
      id="hero"
      className="hero-banner"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`slide ${index === currentSlide ? 'active' : ''} ${
            index === (currentSlide - 1 + slides.length) % slides.length ? 'prev' : ''
          }`}
          style={{
            backgroundImage: `linear-gradient(rgba(201, 79, 30, 0.7), rgba(201, 79, 30, 0.7)), url(${slide.image})`,
          }}
        >
          <div className="container hero-content">
            <h2 className="slide-title">{slide.title}</h2>
            <p className="slide-subtitle">{slide.subtitle}</p>
          </div>
        </div>
      ))}

      <button
        className="nav-button prev"
        onClick={prevSlide}
        aria-label="Slide anterior"
        tabIndex={0}
      >
        &#10094;
      </button>
      <button
        className="nav-button next"
        onClick={nextSlide}
        aria-label="Próximo slide"
        tabIndex={0}
      >
        &#10095;
      </button>

      <div className="dots-container" role="tablist" aria-label="Navegação do carrossel">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Ir para slide ${index + 1}`}
            aria-selected={index === currentSlide}
            role="tab"
            tabIndex={0}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroBanner;
